import QueryString from "qs";
import { GetServerSideProps } from "next";
import ServicesInnerPage from "@/Components/pages/Services-inner";
import GhostPage from "@/Components/pages/GhostPage";
import ServicesPage from "@/Components/pages/Services";

const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_API_BASE_URL;

const map: any = {
  "AI software services": "ai-services",
  "Enterprise Platform Solutions": "enterprise-platforms-solutions",
  "Software Services": "software-services",
};

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  if (process.env.NEXT_PUBLIC_CACHE_PAGES) {
    ctx.res.setHeader(
      "Cache-Control",
      "public, s-maxage=1800, stale-while-revalidate=59",
    );
  }

  const slug = ctx.params?.slug as string;

  const userAgent = ctx.req.headers["user-agent"] || "";
  const isMobile =
    /iphone|ipod|android.*mobile|blackberry|iemobile|opera mini/i.test(
      userAgent,
    );

  let isOldPagev14 = false;
  let isNew = false;

  if (slug === "services") {
    return {
      redirect: {
        permanent: true,
        destination: "/services",
      },
    };
  }

  const query = QueryString.stringify(
    {
      filters: {
        slug: {
          $eq: slug,
        },
      },
      populate: "deep,10",
    },
    {
      encodeValuesOnly: false,
    },
  );

  let apiRes = await fetch(
    `${baseUrl}services-page-v2s?${decodeURIComponent(query)}`,
  );
  let apiResData = await apiRes.json();

  let listData = apiResData?.data;

  const serviceTemplate = listData?.[0]?.attributes?.template;
  const serviceParent = listData?.[0]?.attributes?.parent;

  if (serviceTemplate === "ChildService") {
    return {
      redirect: {
        permanent: true,
        destination: `/services/${map[serviceParent]}/${slug}`,
      },
    };
  }

  /* Remove When All pages are ready --- start */
  if (!listData.length) {
    apiRes = await fetch(`${baseUrl}services?${decodeURIComponent(query)}`);
    apiResData = await apiRes.json();

    listData = apiResData?.data;
    isOldPagev14 = true;
    isNew = listData.template === "main-v2"; // Extract isNew from server-side
  }
  /* Remove When All pages are ready --- start */

  if (!listData.length) {
    return { notFound: true };
  }

  return {
    props: {
      apiResData,
      slug,
      isNew,
      isOldPagev14,
      isMobile,
    },
  };
};

interface ServiceProps {
  apiResData: any;
  isNew?: boolean;
  isOldPagev14?: boolean;
  slug: string;
  isMobile?: boolean;
}

const SubService: React.FC<ServiceProps> = ({
  apiResData,
  slug,
  isMobile,
  isOldPagev14,
}) => {
  const listData = apiResData?.data;
  const blocksData = listData[0]?.attributes.blocks ?? null;
  const seoData = listData[0]?.attributes.seo ?? null;
  const breadcrumbs = listData[0]?.attributes?.breadcrumbs ?? null;

  return (
    <div id="root">
      {isOldPagev14 ? (
        <>
          {apiResData.data[0].attributes.template === "ghost-page" ? (
            <GhostPage slug={slug} data={apiResData} />
          ) : (
            <ServicesPage slug={slug} data={apiResData} />
          )}
        </>
      ) : (
        <ServicesInnerPage
          slug={slug}
          data={blocksData}
          seo={seoData}
          isMobile={isMobile}
          breadcrumbs={breadcrumbs}
        />
      )}
    </div>
  );
};

export default SubService;
